import React, { useEffect, useState, Children } from "react";
import styled, { keyframes } from "react-emotion";

const fadeOut = keyframes`
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
`;

const Child = styled("div")`
  /* animation: ${fadeOut};
  animation-duration: ${(props) => `${props.time}ms`}; */
`;

function Carousel({ style, time, children }) {
  const [id, setId] = useState(0);
  const childrenArray = Children.toArray(children);
  const timer = () => {
    const currentId = id >= childrenArray.length - 1 ? 0 : id + 1;
    setId(currentId);
  };

  useEffect(() => {
    const timerId = setInterval(timer, time);
    return () => clearInterval(timerId);
  }, [id]);

  return (
    <div style={style}>
      <Child time={time}>{childrenArray[id]}</Child>
    </div>
  );
}

export default Carousel;
